export default function* processError(err) {
  yield console.error(err); // eslint-disable-line
  // const {
  //   // errCode,
  //   errMsg,
  //   message,
  //   result,
  // } = err;
  // const title = errMsg || message;
  // const msg = typeof result === 'string' ? result : undefined;
  // yield put(errorNotification({
  // title,
  // message: !!msg ? msg : title
  // }));
}
